import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { HttpApiClient } from "../../axios/axiosInstance";
import {
  bookingActionService,
  bookingsByFilterService,
  cancelBookingService,
  fetchTransactionsService,
  initiateBookingService,
} from "../../services";

const initialState = {
  initiateBookingPayload: [],
  initiateBookingLoading: false,
  initiateBookingErrors: null,
  bookings: [],
  bookingsLoading: false,
  bookingsErrors: null,
  transactions: [],
  transactionsLoading: false,
  transactionsErrors: null,
};

export const initiateBooking = createAsyncThunk(
  "booking/initiateBooking",
  async (request) => {
    const response = await HttpApiClient.post(initiateBookingService, request);
    return response.data.data;
  }
);

export const bookingAction = createAsyncThunk(
  "booking/bookingAction",
  async (request) => {
    const response = await HttpApiClient.put(
      `${bookingActionService}/${request.bookingId}/action`,
      request
    );
    return response.data.payload;
  }
);

export const fetchBookingsByFilter = createAsyncThunk(
  "booking/fetchBookingsByFilter",
  async (request) => {
    const response = await HttpApiClient.post(bookingsByFilterService, request);
    return response.data.data;
  }
);

export const fetchTransactions = createAsyncThunk(
  "booking/fetchTransactions",
  async (request) => {
    const response = await HttpApiClient.get(fetchTransactionsService);
    return response.data.data;
  }
);



export const cancelBooking = createAsyncThunk(
  "booking/cancelBooking",
  async (request) => {
    const response = await HttpApiClient.post(cancelBookingService, request);
    return response.data;
  }
);

const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(initiateBooking.pending, (state) => {
        state.initiateBookingLoading = true;
        state.initiateBookingErrors = null;
      })
      .addCase(initiateBooking.fulfilled, (state, action) => {
        state.initiateBookingLoading = false;
        state.initiateBookingPayload = action.payload;
      })
      .addCase(initiateBooking.rejected, (state, action) => {
        state.initiateBookingLoading = false;
        state.initiateBookingErrors = action.payload;
      })
      .addCase(fetchBookingsByFilter.pending, (state) => {
        state.bookingsLoading = true;
        state.bookingsErrors = null;
      })
      .addCase(fetchBookingsByFilter.fulfilled, (state, action) => {
        state.bookingsLoading = false;
        state.bookings = action.payload;
      })
      .addCase(fetchBookingsByFilter.rejected, (state, action) => {
        state.bookingsLoading = false;
        state.bookingsErrors = action.payload;
      })
      .addCase(fetchTransactions.pending, (state) => {
        state.transactionsLoading = true;
        state.transactionsErrors = null;
      })
      .addCase(fetchTransactions.fulfilled, (state, action) => {
        state.transactionsLoading = false;
        state.transactions = action.payload;
      })
      .addCase(fetchTransactions.rejected, (state, action) => {
        state.transactionsLoading = false;
        state.transactionsErrors = action.payload;
      });
  },
});

export default bookingSlice.reducer;
